import { useQuery } from "@tanstack/react-query";
import { getLocationGroupOptions } from "services/data.internal.service";
import { getLocationOptions } from "services/data.internal.service";

export const useLocationOptionsQuery = ({
  queryKey = "location-options",
  whCode,
  zoneID,
  enabled,
  onSuccess,
}) => {
  let isEnabled = enabled;
  if (enabled === undefined) {
    isEnabled = whCode !== null && zoneID !== null;
  }
  return useQuery({
    queryKey: [queryKey, { whCode, zoneID }],
    queryFn: () => getLocationOptions({ whCode, zoneID }),
    enabled: isEnabled,
    onSuccess,
  });
};

export const useLocationGroupOptionsQuery = ({
  queryKey = "location-group-options",
  enabled,
  onSuccess,
}) => {
  let isEnabled = enabled;
  if (isEnabled === undefined) {
    isEnabled = true;
  }
  return useQuery({
    queryKey: [queryKey],
    queryFn: () => getLocationGroupOptions(),
    enabled: isEnabled,
    onSuccess,
  });
};
